import { Button } from '@imprivata-cloud/components';
import ProductCardPattern from '../../../../assets/product_card_pattern.svg?react';
import './UnpurchasedProductCard.less';
import type { NonPurchasedProduct } from '../../../../api/types';

type UnpurchasedProductCardProps = {
  product: NonPurchasedProduct;
};

export const UnpurchasedProductCard = ({ product }: UnpurchasedProductCardProps) => {
  return (
    <div className={`non-purchased-card ${product.productTag}`}>
      <div className={'title-container'}>
        <ProductCardPattern style={{ position: 'absolute', top: 0, right: 0 }} />
        <div className={'title'}>{product.displayName}</div>
      </div>
      <div className={'link-container'}>
        <Button
          className={'link'}
          label={'Learn more'}
          size={'small'}
          type={'link'}
          href={product.learnMoreUrl}
          target={'_blank'}
          rel="noreferrer"
        />
      </div>
    </div>
  );
};
